import Cookies, { CookiesStatic, CookieAttributes } from 'js-cookie'

class FavouriteExperience {
  protected cookieHandler: CookiesStatic
  protected propertyList: string[] = []
  private readonly cookieName: string = 'favourite-experiences'
  private readonly cookieOptions: CookieAttributes = {
    path: '/',
    expires: 365,
    secure: true,
    sameSite: 'lax',
  }

  public constructor() {
    this.cookieHandler = Cookies 

    this.propertyList = this.cookieHandler
      .get(this.cookieName)
      ?.split(',')
      ?.filter(x => x)
      || []
  }

  public add(propertyCode: string): void {
    this.propertyList.push(propertyCode)
    this.refreshCookie()
  }

  public remove(propertyCode: string): void {
    if (!this.has(propertyCode))
      return

    const index = this.propertyList.indexOf(propertyCode)
    this.propertyList.splice(index, 1)

    this.refreshCookie()
  }

  public toggle(propertyCode: string): void {
    if (this.has(propertyCode))
      this.remove(propertyCode)
    else
      this.add(propertyCode)
  }

  public has(propertyCode: string): boolean {
    return this.propertyList.indexOf(propertyCode) !== -1
  }

  private refreshCookie(): void {
    this.cookieHandler.set(
      this.cookieName,
      this.propertyList.join(','),
      this.cookieOptions
    )
  }
}

export default FavouriteExperience
